import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WACalendarOverviewPreviewQuery } from "./__generated__/WACalendarOverviewPreviewQuery.graphql";
import { WidgetCalendarOverviewPreview } from "widgets/src/WidgetCalendarOverview/WidgetCalendarOverview";

type Props = {
  query: PreloadedQuery<WACalendarOverviewPreviewQuery>;
};

export const WA_CALENDAR_OVERVIEW_PREVIEW_QUERY = graphql`
  query WACalendarOverviewPreviewQuery(
    $input: PreviewWidgetCalendarOverviewInput!
    $storecastId: ID!
    $first: Int
    $after: String
  ) {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetCalendarOverview(input: $input) {
        ...WidgetCalendarOverviewPreview_widget
      }
    }
  }
`;
export function WACalendarOverviewPreview(props: Props) {
  const data = usePreloadedQuery<WACalendarOverviewPreviewQuery>(
    WA_CALENDAR_OVERVIEW_PREVIEW_QUERY,
    props.query
  );
  return (
    <WidgetCalendarOverviewPreview
      widget={data.dashboard.previewWidgetCalendarOverview}
    />
  );
}
